import axios from "axios";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../actions/authActions";
import { getDocs, getDocsByOffice, getDocsReq } from "../actions/getDocs";
import { loadNotifications } from "../actions/loadNotifications";
import { loadRoutes } from "../actions/loadRoutes";
import { resetDocForm } from "../actions/resetDocFom";
import { IP } from "../config/IP";
import store from "../store/createStore";
import "./Dashboard.css";
import Notifications from "./Notifications";
import { LeftSideScreen } from "./SideScreen";
import PrimarySearchAppBar from "./TopToolBar";
//import HomeEditingDoc from "./HomeEditingDoc";

//https://codepen.io/themustafaomar/pen/jLMPKm
function NotificationScreen(props) {
	//console.log("IP.nodeServer=", IP.nodeServer + "api/getDocsAggregates");
	const notitifcationRef = useRef(null);
	const dispatch = useDispatch();

	//start get docs

	{
	}

	//end of docs
	var buffer;
	let image;
	const state = useSelector((state) => state);
	try {
		buffer = Buffer.from(state.auth.user.image.data);
		image = "data:image/png;base64," + buffer.toString("base64");
	} catch (e) {}
	//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
	const [showscreen, setShowscreen] = React.useState("");
	const [imageSrc, setImageSrc] = React.useState(image);
	let imageltvar;
	try {
		imageltvar = store
			.getState()
			.auth.user.allUser.find(
				(y) => y._id === store.getState().auth.user.usernameId
			).username;
	} catch (e) {}

	const [imageAlt, setImageAlt] = React.useState(imageltvar);
	const [username, setUsername] = React.useState(imageltvar);
	const [office_name, setOffice_name] = React.useState(imageltvar);
	const [screen, setScreen] = React.useState();

	const notificationRef = useRef(null);
	const [notification, setNotification] = React.useState();
	const token = localStorage.getItem("token");

	let item = [];

	let actingOffices = {};
	if (state.userStatus.status.actingOffice) {
		actingOffices = state.userStatus.status.actingOffice
			.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
			.map((x) => x.officeActingOnBehalf);
	}

	const setNotificationFx = (data) => {
		if (state.getNotications.isLoaded) {
			console.log("setNotificationFx in TopToolBar Data=", data);
			item = [];

			let photo = {};
			const config = {
				headers: {
					"x-auth-token": token,
					"content-type": "application/json",
				},
			};

			try {
				state.getNotications.notifications.NotificationResp.docs
					.sort((x, y) => {
						return x.createDate > y.createDate ? 1 : -1;
					})
					.map(async (x, index) => {
						let username = state.auth.user.allUser.find(
							(y) => y._id === x.senderUsernameId
						).username;
						let output = await axios.get(
							IP.nodeServer + "api/profileimage/" + username,
							config
						);
						//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
						console.log("return output=", output);
						if (output) {
							try {
								var buffer = Buffer.from(
									output.data.image.picture.data
								).toString("base64");

								photo = "data:image/png;base64," + buffer.toString(buffer);
							} catch (e) {
								photo = "person.png";
							}

							item.push({
								key: x._id,
								id: x.docId,
								createDate: x.createDate,
								readstatus: x.readstatus,
								readstatusDate: x.readstatusDate,

								username: username,
								message: x.message,
								photo: photo,
							});
							//if (item.length===index)
							console.log("index =", index);
							console.log("item =", item.length);
						}
						try {
							notificationRef.current.putItems(item);
						} catch (e) {}
					});
			} catch (e) {}
		}
	};

	const setnewProfilePicture = (value) => {
		if (value) {
			console.log("Dashboard setnewProfilePicture issued");
			var buffer = Buffer.from(store.getState().userStatus.image.data);

			setImageSrc("data:image/png;base64," + buffer.toString("base64"));
		}
	};

	


	useEffect(() => {
		try {
			actingOffices = state.userStatus.status.actingOffice
				.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
				.map((x) => x.officeActingOnBehalf);
		} catch (e) {}
		let office_idv;
		try {
			office_idv = state.auth.user.office[0].office_id;
		} catch (e) {}
		let inputs = {
			url: IP.nodeServer + "api/getNotifications",
			method: "POST",
			data: [
				{ name: "office_id", value: office_idv },
				{
					name: "actingOffices",
					value: actingOffices,
				},
				{
					name: "limit",
					value: 100,
				},
				{ name: "page", value: 1 },
			],
		};
		console.log("Notification inputs", inputs);
		if (office_idv) dispatch(loadNotifications(inputs));
	}, []);

	useEffect(() => {
		console.log(
			"state.getNotications.notifications",
			state.getNotications.notifications
		);

		if (state.getNotications.isLoaded) {
			setNotificationFx(state.getNotications.notifications.data);
		}
	}, [state.getNotications.isLoading, state.getNotications.isLoaded]);

	return (
		<div className="container">
			<LeftSideScreen
				//openEditing={openEditing}
				//openAllDocs={openAllDocs}
				//showDocumentTable={showDocumentTable}
				imageSrc={imageSrc}
				imageAlt={imageAlt}
				office_name={office_name}
				username={username}
				setnewProfilePicture={setnewProfilePicture}
			/>

			<section id="contents">
				<PrimarySearchAppBar ref={notitifcationRef} />
			</section>
			<Notifications ref={notificationRef} item={notification} />
		</div>
	);
}

const mapDispatchToProps = (dispatch) => ({
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	getDocs: (data) => dispatch(getDocs(data)),
	logoutUser: () => dispatch(logoutUser()),
	getDocsByOffice: (data) => dispatch(getDocsByOffice(data)),
	resetDocForm: () => dispatch(resetDocForm()),
	getDocsReq: (data) => dispatch(getDocsReq(data)),
});
const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps, mapDispatchToProps)(NotificationScreen);
